import {Injectable, OnDestroy} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, Subject, Subscription, throttleTime} from 'rxjs';
import {environment} from '../../environments/environment';
import {logUtishaWarn} from '../util/log';
import {UserControllerService} from '@api/utisha-backend';

@Injectable({
  providedIn: 'root'
})
export class LastActiveInterceptor implements HttpInterceptor, OnDestroy {

  private lastActiveSubject = new Subject<void>();
  private subscription: Subscription = new Subscription();

  constructor(private userService: UserControllerService) {
    this.subscription.add(
      this.lastActiveSubject
        .pipe(throttleTime(60000))
        .subscribe(() =>
          setTimeout(() => this.updateLastActive(), 5000)
        ));
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.apiUrl) && req.url.indexOf('/users/me/active') === -1) {
      this.lastActiveSubject.next();
    }
    return next.handle(req);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private updateLastActive() {
    this.userService.updateUserActive().subscribe({
      next: () => {
        // do nothing
      },
      error: (err: any) => {
        logUtishaWarn('Last active update failed: ' + JSON.stringify(err, null, 2));
      }
    });
  }
}
